import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import ContentDetailView from "composer/views/content/ContentDetailView.jsx"

import { Icon, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';

class EditContentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleUpdateClicked() {
    // todo: check empty content
    let contentDetailViewState = this.refs.contentDetailView.state;
    let contentDetailView = this.refs.contentDetailView;
    let return_message = contentDetailView.checkEmptyContent();
    console.log('return message:', return_message);
    console.log('content:', contentDetailViewState.contentText);
    console.log('payload:', contentDetailViewState.contentPayload);

    switch(return_message.flag){
      case ContentDetailView.TAG_OK:
        // save tag normally
        console.log('TAG_OK');
        let requestObj = {
          table: "component",
          where_field: "id",
          where_value: this.props.parent.getCurrentContent().id,
          row: {
            name: contentDetailViewState.contentName,
            rationale: contentDetailViewState.contentCategory,
            diff: contentDetailViewState.contentDifficulty,
            content: contentDetailViewState.contentText,
            payload: JSON.stringify(contentDetailViewState.contentPayload),
          }
        };
        this.props.root.refs.API.request("update", requestObj, this.updateContentOK, this.updateContentFail);
        this.handleClose();
        break;

      case ContentDetailView.TAG_WARNING:
        // prompt user
        let dialogText = {
          title: Localization.strings.EXIT,
          content: return_message.message,
          confirm: Localization.strings.YES,
        };
        this.props.root.refs.confirmDialog.show(dialogText, ()=>{
          let requestObj = {
            table: "component",
            where_field: "id",
            where_value: this.props.parent.getCurrentContent().id,
            row: {
              name: contentDetailViewState.contentName,
              rationale: contentDetailViewState.contentCategory,
              diff: contentDetailViewState.contentDifficulty,
              content: contentDetailViewState.contentText,
              payload: JSON.stringify(contentDetailViewState.contentPayload),
            }
          };
          this.props.root.refs.API.request("update", requestObj, this.updateContentOK, this.updateContentFail);
          this.handleClose();
        }, ()=>{});
        break;

      case ContentDetailView.TAG_ERROR:
        // block user from saving this problematic tag
        this.props.root.addNotification(return_message.message, false);
        break;
    }
  }

  updateContentOK(res) {
    this.props.parent.getContentByHotspotID(this.props.parent.props.currentHotspot['id']);
    this.props.root.addNotification(Localization.strings.UPDATED, true);

    var requestObj = {epack_id: this.props.root.getCurrentLocale().id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  updateContentFail(err) {
    console.log("update content fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, false);
  }

  handleCancelClicked() {
    this.handleClose();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogTitle style={{backgroundColor:'#3f51b5',color:"#FFFFFF"}}>
            <Icon style={{fontSize: '36px', verticalAlign:'middle',paddingBottom:'4px',color:'#FFFFFF'}}>
              {Config.GET_HOTSPOT_CONTENT_CONFIG(this.props.parent.getCurrentContent() != null? parseInt(this.props.parent.getCurrentContent().kind) : 0).icon}
            </Icon>
            {" " + Config.GET_HOTSPOT_CONTENT_CONFIG(this.props.parent.getCurrentContent() != null? parseInt(this.props.parent.getCurrentContent().kind) : 0).title}
          </DialogTitle>
          <DialogContent>
            <ContentDetailView root={this.props.root} parent={this} ref="contentDetailView"/>
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              onClick={this.handleCancelClicked}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleUpdateClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default EditContentDialog;
